import React from 'react';
import { Link } from 'react-router-dom';
export function TermsConditionsPage() {
  return <main className="pt-32 pb-24 bg-brand-black min-h-screen" data-id="element-481">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-482">
        <div className="mb-12 border-b border-brand-gold/20 pb-8" data-id="element-483">
          <h1 className="font-heading text-4xl md:text-5xl text-brand-white mb-4" data-id="element-484">
            Terms & Conditions
          </h1>
          <p className="text-brand-gold font-medium" data-id="element-485">
            Effective date: January 1, 2026
          </p>
        </div>

        <div className="prose prose-invert prose-brand max-w-none text-brand-champagne-light/80 space-y-8" data-id="element-486">
          <p className="text-lg leading-relaxed" data-id="element-487">
            These Terms & Conditions govern your use of the Deluxe MedSpa Beauty
            website, appointment request forms, and related services. By using
            this website, you agree to these Terms.
          </p>

          <section data-id="element-488">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-489">
              1. Use of Website
            </h2>
            <p data-id="element-490">
              You agree to use this website only for lawful purposes and in a
              manner that does not infringe the rights of, restrict, or inhibit
              anyone else's use and enjoyment of the website.
            </p>
          </section>

          <section data-id="element-491">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-492">
              2. Appointment Requests
            </h2>
            <p data-id="element-493">
              Submitting an appointment request through our website does not
              guarantee an appointment. All requests are subject to availability
              and confirmation by our staff. We reserve the right to refuse
              service to anyone for any reason at any time.
            </p>
          </section>

          <section data-id="element-494">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-495">
              3. Services and Availability
            </h2>
            <p data-id="element-496">
              Information provided on this website regarding services is for
              general informational purposes only and does not constitute
              medical advice. Treatment outcomes vary by individual. We reserve
              the right to modify or discontinue any service without notice.
            </p>
          </section>

          <section data-id="element-497">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-498">
              4. Payments and Promotions
            </h2>
            <p data-id="element-499">
              Prices for our services are subject to change without notice. Any
              promotional offers presented on the website or via SMS are subject
              to specific terms and conditions and may be withdrawn at any time.
            </p>
          </section>

          <section data-id="element-500">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-501">
              5. Communications
            </h2>
            <p data-id="element-502">
              By providing your contact information, you agree that we may
              contact you regarding your inquiries, appointments, and services.
              You may opt out of promotional communications at any time.
            </p>
          </section>

          <section data-id="element-503">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-504">
              6. SMS Messaging Terms
            </h2>
            <div className="bg-brand-charcoal border-l-4 border-brand-gold p-6 rounded-r-sm space-y-4" data-id="element-505">
              <p className="text-brand-white leading-relaxed font-medium" data-id="element-506">
                By providing your phone number and affirmatively opting in, you
                agree to receive SMS text messages from Deluxe MedSpa Beauty
                related to your inquiry, appointment scheduling, appointment
                confirmations, reminders, service-related updates, and, if
                separately consented to, promotional offers. Message frequency
                may vary. Msg & data rates may apply. Reply STOP to opt out.
                Reply HELP for help. Consent is not a condition of purchase.
              </p>
              <p className="text-brand-champagne-light/70 text-sm" data-id="element-507">
                Wireless carriers are not liable for delayed or undelivered
                messages.
              </p>
            </div>
          </section>

          <section data-id="element-508">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-509">
              7. Intellectual Property
            </h2>
            <p data-id="element-510">
              All content on this website, including text, graphics, logos, and
              images, is the property of Deluxe MedSpa Beauty and is protected
              by intellectual property laws. You may not reproduce, distribute,
              or create derivative works without our express written consent.
            </p>
          </section>

          <section data-id="element-511">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-512">
              8. Limitation of Liability
            </h2>
            <p data-id="element-513">
              To the fullest extent permitted by law, Deluxe MedSpa Beauty shall
              not be liable for any direct, indirect, incidental, consequential,
              or punitive damages arising out of your access to or use of this
              website or our services.
            </p>
          </section>

          <section data-id="element-514">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-515">
              9. Governing Law
            </h2>
            <p data-id="element-516">
              These Terms & Conditions shall be governed by and construed in
              accordance with the laws of the State of Florida, without regard
              to its conflict of law provisions.
            </p>
          </section>

          <section data-id="element-517">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-518">
              10. Contact Information
            </h2>
            <p className="mb-4" data-id="element-519">
              If you have any questions about these Terms & Conditions, please
              contact us at:
            </p>
            <div className="bg-brand-charcoal/50 p-6 rounded-sm border border-brand-charcoal inline-block" data-id="element-520">
              <address className="not-italic text-brand-white" data-id="element-521">
                <strong className="text-brand-gold block mb-2 font-heading text-xl" data-id="element-522">
                  Deluxe MedSpa Beauty
                </strong>
                30 SW 1st St #1001
                <br data-id="element-523" />
                Miami, FL 33132
                <br data-id="element-524" />
                Phone: 786-901-0611
              </address>
            </div>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-gold/20 flex flex-wrap gap-6" data-id="element-525">
          <Link to="/privacy-policy" className="text-brand-gold hover:text-brand-gold-light transition-colors" data-id="element-526">
            &larr; Read Privacy Policy
          </Link>
          <Link to="/sms-terms" className="text-brand-gold hover:text-brand-gold-light transition-colors" data-id="element-527">
            Read SMS Terms &rarr;
          </Link>
        </div>
      </div>
    </main>;
}